<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      clip-rule="evenodd"
      d="M13 3C13 2.44772 12.5523 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.4477 21.5523 11 21 11C20.4477 11 20 11.4477 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C12.5523 4 13 3.55228 13 3ZM12.9933 7.88338C12.9355 7.38604 12.5128 7 12 7C11.4477 7 11 7.44772 11 8V13L11.0087 13.1314C11.0374 13.3481 11.1366 13.5508 11.2929 13.7071L13.7929 16.2071L13.8871 16.2903C14.2794 16.5953 14.8466 16.5676 15.2071 16.2071L15.2903 16.1129C15.5953 15.7206 15.5676 15.1534 15.2071 14.7929L13 12.585V8L12.9933 7.88338ZM19 5.79557L20.3279 7.12324L20.4221 7.20643C20.8144 7.51146 21.3817 7.48373 21.7421 7.12324C22.1327 6.73272 22.1327 6.09956 21.7421 5.70903L18.7069 2.67375L18.6127 2.59056C18.2204 2.28554 17.6531 2.31327 17.2926 2.67375L14.2743 5.69206L14.1911 5.78627C13.8861 6.17856 13.9139 6.74579 14.2743 7.10628L14.3685 7.18947C14.7608 7.49449 15.3281 7.46676 15.6886 7.10628L17 5.79394V8.95756L17.0067 9.07418C17.0645 9.57152 17.4872 9.95756 18 9.95756C18.5523 9.95756 19 9.50984 19 8.95756V5.79557Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
